import { t } from "i18next";
import { z } from "zod";

export const SignInSchema = z.object({
  email: z
    .string()
    .email(t("schemas.signIn.email.email"))
    .min(1, t("schemas.signIn.email.min")),
  password: z.string().min(2, t("schemas.signIn.password.min")),
});

export type SignInSchemaType = z.infer<typeof SignInSchema>;
